
(() => {
  const sectionSelector = '.zento-nosotros-timeline';
  const itemSelector = '.zento-nosotros-timeline__item';
  const reducedMotionQuery = '(prefers-reduced-motion: reduce)';

  function initTimeline(section) {
    if (!section || section.dataset.timelineInitialized === 'true') {
      return;
    }

    section.dataset.timelineInitialized = 'true';

    const items = section.querySelectorAll(itemSelector);

    if (!items.length) return;

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia(reducedMotionQuery).matches
    ) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    section.classList.add('zento-nosotros-timeline--js');

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    items.forEach((item) => observer.observe(item));
  }

  function initAllTimelines(root = document) {
    if (root.matches?.(sectionSelector)) {
      initTimeline(root);
    }

    root.querySelectorAll?.(sectionSelector).forEach(initTimeline);
  }

  function init() {
    initAllTimelines();

    document.addEventListener('shopify:section:load', (event) => {
      initAllTimelines(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
